import './FilterOptionBoxItem.scss';

import { createClsNameMap, formatLabelFilterOption, mapModifiers, stripHtml } from '@utils';

import type { FilterOptionItemSettings } from '@/features/filter-product-list/filter/FilterOptionItem';
import {
  FilterOptionItem,
  useFilterOptionItem,
} from '@/features/filter-product-list/filter/FilterOptionItem';
import FilterOptionItemButton from '@/features/filter-product-list/filter/FilterOptionItem/Button';
import FilterOptionItemLabel from '@/features/filter-product-list/filter/FilterOptionItem/Label';

export const clsNameMap = createClsNameMap({
  modifiers: ['selected', 'disabled'],
})('filter-option-box-item');

export type FilterOptionBoxItemProps = {
  filterOptionId: string;
  value: string;
  docCount?: number;
  settings: FilterOptionItemSettings;
  prefix: string | undefined;
};

const FilterOptionBoxItem = ({
  value,
  filterOptionId,
  settings,
  docCount,
  prefix,
}: FilterOptionBoxItemProps) => {
  const { isOptionItemSelected, handleOptionItemSelect, showOutOfStockOption } =
    useFilterOptionItem({
      value,
      filterOptionId,
    });

  const disabled = docCount === 0;

  if (!showOutOfStockOption && disabled) return null;

  if (!stripHtml(value)) return null;

  return (
    <FilterOptionItem
      className={mapModifiers(clsNameMap, { selected: isOptionItemSelected, disabled })}
    >
      <FilterOptionItemButton
        as='button'
        isSelected={isOptionItemSelected}
        modifiers={['items-center']}
        showFilterOptionCount={false} // box always = false, not show
        label={
          <FilterOptionItemLabel
            label={formatLabelFilterOption(value, prefix)}
            settings={{
              displayAllValuesInUppercaseForm: settings.displayAllValuesInUppercaseForm,
            }}
          />
        }
        onClick={handleOptionItemSelect}
      />
    </FilterOptionItem>
  );
};

export default FilterOptionBoxItem;
